import { useEffect, useRef, useState } from 'react'

import { getMockApplicantViewings } from '../../../../../../RentalPortalApplicant'
import {
  APPLICANT_VIEWING_CARD_PAGE,
  APPLICANT_VIEWING_CARD_PAGE_SIZE,
} from '../../ApplicantViewingCard.constants'

export function useApplicantViewingCard({ applicantId }) {
  const [reloadKey, setReloadKey] = useState(0)

  const [items, setItems] = useState(null)
  const [hasError, setError] = useState(false)
  const [isInitiated, setInitiated] = useState(false)

  const readIdRef = useRef(0)

  function handleRefresh() {
    setReloadKey(prevKey => prevKey + 1)
  }

  useEffect(() => {
    if (applicantId) {
      readIdRef.current += 1

      const readId = readIdRef.current

      getMockApplicantViewings({
        applicant_id: applicantId,
        page: APPLICANT_VIEWING_CARD_PAGE,
        page_size: APPLICANT_VIEWING_CARD_PAGE_SIZE,
      })
        .then(({ data }) => {
          if (readIdRef.current === readId) {
            setItems(data.items)
            setError(false)
            setInitiated(true)
          }
        })
        .catch(() => {
          if (readIdRef.current === readId) {
            setError(true)
            setInitiated(true)
          }
        })
    }
  }, [applicantId, reloadKey])

  return { handleRefresh, hasError, isInitiated, items }
}
